import {
  easypostFedexMfaValidatePinInputSchema,
  easypostFedexMfaValidatePinOutputSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/easypost-fedex-mfa";

export const easypostFedexMfaValidatePin = {
  name: "easypostFedexMfaValidatePin" as const,
  input: easypostFedexMfaValidatePinInputSchema,
  output: easypostFedexMfaValidatePinOutputSchema,
};
